import { SingleSlot } from './Slot';
import { SlotMapper } from './mappers/SlotMapper';

export interface BlockedSlot {
  childArticleNumber: string;
  slot: SingleSlot;
}

export class BlockedSlotMapper {
  static toDto = (usedSlot: BlockedSlot): CoreServiceAPI.BlockedSingleSlotInstanceInDto => ({
    childArticleNumber: usedSlot.childArticleNumber,
    ...SlotMapper.toDto(usedSlot.slot)
  });

  static from = (slot: SingleSlot, childArticleNumber: string): BlockedSlot => ({
    slot,
    childArticleNumber
  });
}
